module.exports = __webpack_public_path__ + "img/about-makuta.11b486ce.png";